/** @format */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UriDecodePipe } from './uri-decode/uri-decode.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [UriDecodePipe],
  exports: [UriDecodePipe]
})
export class SharedUtilsPipesModule {}
